import { render, staticRenderFns } from "./MyProfileDrawer.vue?vue&type=template&id=6fafb6d2&scoped=true&"
import script from "./MyProfileDrawer.vue?vue&type=script&lang=js&"
export * from "./MyProfileDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MyProfileDrawer.vue?vue&type=style&index=0&id=6fafb6d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fafb6d2",
  null
  
)

export default component.exports